module.exports = __webpack_public_path__ + "people_after.c35c5f06.png";